// Navbar.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

function Navbar({ isEnglish, toggleLanguage, theme, toggleTheme, onCartClick }) {
  const navigate = useNavigate();
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const count = parseInt(sessionStorage.getItem("cart-count")) || 0;
    setCartCount(count);

    const handleStorageChange = () => {
      const newCount = parseInt(sessionStorage.getItem("cart-count")) || 0;
      setCartCount(newCount);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleLanguageChange = (lang) => {
    if ((lang === "en" && !isEnglish) || (lang === "ar" && isEnglish)) {
      toggleLanguage();
    }
    setShowLanguageMenu(false);
  };

  return (
    <header>
      <div className="container">
        <div
          className="imge"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <img src="./MainLogo.jpeg" alt="logo" />
        </div>

        <div>
          <h2 onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            {isEnglish ? "DIGISMA" : "ديجيسما"}
          </h2>
          <p>{isEnglish ? "Relax, leave it to us!" : "خدمات تقنية ذكية"}</p>
        </div>
      </div>

      {/* ✅ Desktop Nav */}
      <ul className="desktop-nav">
        <li><button onClick={() => navigate("/")}>{isEnglish ? "Home" : "الرئيسية"}</button></li>
        <li><button onClick={() => navigate("/about")}>{isEnglish ? "About" : "عنا"}</button></li>
        <li><button onClick={() => navigate("/projects")}>{isEnglish ? "Projects" : "المشاريع"}</button></li>
        <li><button onClick={() => navigate("/contact")}>{isEnglish ? "Contact" : "تواصل"}</button></li>
      </ul>

      {/* ✅ Mobile Nav */}
      <div className="hamburger-menu" onClick={() => setShowMobileNav(!showMobileNav)}>
        <i className="fas fa-bars"></i>
      </div>

      {showMobileNav && (
        <ul className="mobile-nav">
          <li><button onClick={() => { navigate("/"); setShowMobileNav(false); }}>{isEnglish ? "Home" : "الرئيسية"}</button></li>
          <li><button onClick={() => { navigate("/about"); setShowMobileNav(false); }}>{isEnglish ? "About" : "عنا"}</button></li>
          <li><button onClick={() => { navigate("/projects"); setShowMobileNav(false); }}>{isEnglish ? "Projects" : "المشاريع"}</button></li>
          <li><button onClick={() => { navigate("/contact"); setShowMobileNav(false); }}>{isEnglish ? "Contact" : "تواصل"}</button></li>
        </ul>
      )}

      <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
        {/* ✅ Cart */}
        <div className="cart-icon">
          <ul>
            <li onClick={onCartClick}>
              <i className="fa-solid fa-cart-shopping" style={{ fontSize: "20px", cursor: "pointer" }}></i>
            </li>
          </ul>
          {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
        </div>

        {/* ✅ Language */}
        <div className="language-selector">
          <img
            src="./translate_118529.webp"
            alt="Language"
            className="lang-icon"
            onClick={() => setShowLanguageMenu(!showLanguageMenu)}
          />
          {showLanguageMenu && (
            <div className="language-menu">
              <button className="close-lang-menu" onClick={() => setShowLanguageMenu(false)}>✖</button>
              <button onClick={() => handleLanguageChange("en")}>🇺🇸 English</button>
              <button onClick={() => handleLanguageChange("ar")}>🇸🇦 العربية</button>
            </div>
          )}
        </div>

        {/* ✅ Theme */}
        <div className="theme-toggle-wrapper" onClick={toggleTheme}>
          <div className={`theme-toggle-circle ${theme === "dark" ? "move-right" : "move-left"}`}>
            <i className={theme === "light" ? "fa-regular fa-moon" : "fa-solid fa-sun"}></i>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
